import * as React from 'react';

function BugIconComponent(props: any) {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.47636 4.03702L7.21967 2.78033L8.28033 1.71967L9.9055 3.34483C10.5627 3.12127 11.2672 3 12 3C12.7328 3 13.4372 3.12125 14.0943 3.34478L15.7195 1.71967L16.7801 2.78033L15.5235 4.03693C17.2988 5.1843 18.4791 7.17343 18.4997 9.43961L19.5 8.43933V6.5H21V9.06066L18.5 11.5607V13H22V14.5H18.5V15.5C18.5 15.643 18.4954 15.7849 18.4863 15.9256L21.0001 18.4393V21H19.5001V19.0607L18.1238 17.6844C17.2265 20.1997 14.8235 22 12 22C9.17652 22 6.77351 20.1997 5.87619 17.6845L4.5 19.0607V21H3V18.4393L5.51371 15.9256C5.50462 15.7849 5.5 15.643 5.5 15.5V14.5H2V13H5.5V11.5607L3 9.06066V6.5H4.5V8.43934L5.50027 9.43961C5.5209 7.17349 6.70116 5.18439 8.47636 4.03702ZM7.10002 8.5H16.9C16.4367 6.21776 14.419 4.5 12 4.5C9.58104 4.5 7.56329 6.21776 7.10002 8.5ZM17 10H12.75V20.4441C15.1556 20.0823 17 18.0065 17 15.5V10ZM11.25 20.4441V10H7V15.5C7 18.0065 8.84437 20.0823 11.25 20.4441Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default BugIconComponent;
